var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExclamation = function SvgExclamation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47748 0 0 4.47748 0 10C0 15.5232 4.47748 20 10 20C15.5232 20 20 15.5238 20 10C20 4.47748 15.5231 0 10 0ZM10 18.125C5.51253 18.125 1.87503 14.4875 1.87503 10C1.87503 5.51253 5.51253 1.87503 10 1.87503C14.4875 1.87503 18.125 5.51253 18.125 10C18.125 14.4875 14.4875 18.125 10 18.125ZM10.0006 4.38561C9.2844 4.38561 8.74247 4.75938 8.74247 5.36311V10.9006C8.74247 11.505 9.28433 11.8775 10.0006 11.8775C10.6994 11.8775 11.2588 11.4894 11.2588 10.9006V5.36311C11.2587 4.77371 10.6994 4.38561 10.0006 4.38561ZM10.0006 13.125C9.31251 13.125 8.75247 13.685 8.75247 14.3737C8.75247 15.0612 9.31251 15.6212 10.0006 15.6212C10.6888 15.6212 11.2482 15.0612 11.2482 14.3737C11.2481 13.685 10.6888 13.125 10.0006 13.125Z",
    fill: "#FDBE14"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclamation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation.6ce10727.svg";
export { ForwardRef as ReactComponent };